import React, { useState, useEffect } from 'react';
import {
    Box,
    Typography,
    IconButton,
    Dialog,
    Button,
    Tooltip,
} from '@material-ui/core';
import {
    ArrowBack,
    CloudUpload,
} from '@material-ui/icons';
import { createStyles, Theme, makeStyles } from '@material-ui/core/styles';
import { useHistory } from 'react-router-dom';
import {
    SelectListSignal,
} from 'presentation/events';
import {
    mediateSelectedListInfoDependent,
    mediateSelectTaskListRequester,
    mediateEntriesInfoDependent,
} from 'mediators';
import { StatementImport } from 'presentation/StatementImport';
import { useSelector, useDispatch } from 'react-redux';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        header: {
            backgroundColor: '#1e3a8a',
            color: 'white',
            padding: '0 12px',
        },
        topRow: {
            display: 'flex',
            alignItems: 'center',
            height: '56px',
        },
        listName: {
            fontWeight: 700,
            fontSize: '1.1rem',
            flexGrow: 1,
            marginLeft: '4px',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        },
        iconBtn: {
            color: 'rgba(255,255,255,0.85)',
            '&:hover': { color: 'white', backgroundColor: 'rgba(255,255,255,0.1)' },
        },
    })
);

export const Header = (props) => {
    const classes = useStyles();
    const history = useHistory();
    const dispatch = useDispatch();
    const entries: any[] = useSelector(mediateEntriesInfoDependent) || [];
    const list: any = useSelector(mediateSelectedListInfoDependent);

    const [showImport, setShowImport] = useState(false);

    const [selectListSignal] = useState(new SelectListSignal());

    useEffect(() => { return mediateSelectTaskListRequester(selectListSignal, dispatch).destroy; }, [selectListSignal, dispatch]);

    return (
        <>
            <Box className={classes.header}>
                <Box className={classes.topRow}>
                    <Tooltip title="Back">
                        <IconButton
                            size="small"
                            className={classes.iconBtn}
                            onClick={() => { selectListSignal.dispatch(null); history.push('/home'); }}
                        >
                            <ArrowBack />
                        </IconButton>
                    </Tooltip>

                    <Typography className={classes.listName}>{list?.displayName}</Typography>

                    <Tooltip title="Import Statement">
                        <IconButton size="small" className={classes.iconBtn} onClick={() => setShowImport(true)}>
                            <CloudUpload />
                        </IconButton>
                    </Tooltip>
                </Box>

                <Box style={{ paddingBottom: '8px', paddingLeft: '4px' }}>
                    <Typography style={{ fontSize: '0.7rem', opacity: 0.6 }}>
                        {entries.length} {entries.length === 1 ? 'entry' : 'entries'}
                    </Typography>
                </Box>
            </Box>

            {/* Import Statement dialog */}
            <Dialog fullScreen open={showImport}>
                <Box display="flex" flexDirection="column" style={{ height: '100vh', overflow: 'hidden' }}>
                    <Box style={{ backgroundColor: '#1e3a8a', color: 'white', padding: '12px 16px', display: 'flex', alignItems: 'center', flexShrink: 0 }}>
                        <CloudUpload style={{ marginRight: '8px' }} />
                        <Typography variant="h6" style={{ fontWeight: 700, flexGrow: 1, fontSize: '1rem' }}>Import Bank Statement</Typography>
                        <Button onClick={() => setShowImport(false)} style={{ color: 'white' }}>Close</Button>
                    </Box>
                    <Box style={{ flex: 1, overflow: 'hidden' }}>
                        <StatementImport onDone={() => setShowImport(false)} />
                    </Box>
                </Box>
            </Dialog>
        </>
    );
};
